import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Vimeo from '@u-wave/react-vimeo';

export const VimeoVideo = props =>

  <section className={props.sectionClassNames}>
    <div className="row">
      <div className="col-lg-12">
        {props.content.fieldGroesse === '0' &&
        <div className="full-width">
          <Vimeo
            video={props.content.fieldVimeoVideoUrl}
            responsive
            controls={true}
          />
        </div>
        }
        {props.content.fieldGroesse === '1' &&
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-6 offset-lg-3">
              <Vimeo
                video={props.content.fieldVimeoVideoUrl}
                responsive
              />
            </div>
          </div>
        </div>
        }
      </div>
    </div>

  </section>
;

VimeoVideo.propTypes = {
  content: PropTypes.object.isRequired,
  sectionClassNames: PropTypes.string
};
